import { render, staticRenderFns } from "./BvaTipTap.vue?vue&type=template&id=1f7e1b03&"
import script from "./BvaTipTap.vue?vue&type=script&lang=ts&"
export * from "./BvaTipTap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports